module.exports = __webpack_public_path__ + "resources/arrow-up-6a99a60ed6424e811cd228c6965f9dce.png";


//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/resources/images/arrow-up.png
// module id = 81
// module chunks = 0